<template lang="pug">
  div

    active-item
      div.searchbar(:class="{active: active}" slot-scope="{ setActive, active }")
        div.searchbar__content

          //- CLOSE MOBILE
          //--------------------------------------------
          div(class="lg:hidden" :class="{hidden: !active}")
            .h3(class="p-8 text-secondary flex justify-between")
              span Filtrer la recherche
              div(@click.prevent="setActive(false)")
                i.far.fa-times

          //- FILTRE DESKTOP
          //--------------------------------------------
          .row.no-gutter.items-start

            //- LOCATION MULTISELECT
            .col-12.no-gutter(:class="[isRental ? 'lg:col-2' : 'lg:col-3']")
              .row.no-gutter

                //- Select
                .col-9.no-gutter(class="sm:col-10 lg:col-12" :class="{'col-12 sm:col-12' : active}")
                  location-select(
                    :initial-cities="searchParams.by_cities"
                    :cities="cities"
                  )

                //- Mobile filter
                .col-3.no-gutter(class="sm:col-2 border-l border-gray-smooth lg:hidden" :class="{hidden: active}")
                  open-filter(:on-click="() => setActive(true)")

            //- TYPE MULTISELECT
            .col-12.no-gutter(class="lg:block border-t lg:border-t-0 lg:border-l lg:border-r border-gray-smooth" :class="[{hidden: !active}, isRental ? 'lg:col-2' : 'lg:col-3']")
              sectors-select(
                :initial-sectors="searchParams.by_sectors"
                :sectors="sectors"
              )

            //- TYPE MULTISELECT
            .col-12.no-gutter(class="lg:col-2 lg:block border-t lg:border-t-0 lg:border-r border-gray-smooth" :class="{hidden: !active}")
              type-select(
                :initial-accommodation-type="searchParams.by_accommodation_type"
                :accommodation-types="accommodationTypes"
              )

            //- BEDROOM CHECKBOX
            .col-12.no-gutter(class="lg:col-2 lg:block border-t lg:border-t-0 lg:border-r border-gray-smooth" :class="{hidden: !active}")
              bedroom-checkboxes(
                :initial-bedrooms="searchParams.by_bedrooms"
              )

            //- BUDGET SLIDER
            .col-12.no-gutter(class="lg:col-2 lg:block border-t lg:border-t-0 border-gray-smooth" :class="[{hidden: !active}, isRental ? 'lg:border-r' : '']")
              budget-range(
                :search-params="searchParams"
                :is-rental="isRental"
              )

            //- SURFACE SLIDER
            .col-12.no-gutter(v-if="isRental" class="lg:col-2 lg:block border-t lg:border-t-0 border-gray-smooth" :class="{hidden: !active}")
              surface-range(
                :initial-surface-min="searchParams.by_min_surface"
                :initial-surface-max="searchParams.by_max_surface"
              )

          //- CLOSE MOBILE
          //--------------------------------------------
          div(class="lg:hidden absolute shadow-md bg-white pin-b pin-l pin-r p-5 text-center z-60" :class="{hidden: !active}")
            .btn.btn-primary(@click.prevent="setActive(false)")
              span Appliquer les filtres
</template>

<script>
import LocationSelect from '@components/Searchbar/LocationSelect'
import SectorsSelect from '@components/Searchbar/SectorsSelect'
import OpenFilter from '@components/Searchbar/OpenFilter'
import TypeSelect from '@components/Searchbar/TypeSelect'
import BedroomCheckboxes from '@components/Searchbar/BedroomCheckboxes'
import BudgetRange from '@components/Searchbar/BudgetRange'
import SurfaceRange from '@components/Searchbar/SurfaceRange'

export default {
  components: {
    LocationSelect,
    SectorsSelect,
    OpenFilter,
    TypeSelect,
    BedroomCheckboxes,
    BudgetRange,
    SurfaceRange
  },

  props: {
    cities: {
      type: Array,
      required: true
    },

    sectors: {
      type: Array,
      required: true
    },

    accommodationTypes: {
      type: Array,
      required: true
    },

    searchParams: {
      type: Object,
      required: true
    },

    page: {
      type: Number,
      required: true
    },

    isRental: {
      type: Boolean,
      default: false
    },

    maxBudget: {
      type: [Number, String],
      required: true
    },

    maxSurface: {
      type: [Number, String],
      default: null
    }
  },

  created () {
    Object.entries(this.searchParams).forEach(([key, value]) => {
      this.$store.commit('updateParams', { key: key, value: value })
    })

    this.$store.commit('updateParams', { key: 'page', value: this.page })
    this.$store.commit('setMaxBudget', this.maxBudget)
    this.$store.commit('setMaxSurface', this.maxSurface)

    this.$nextTick(() => {
      if (this.isRental) {
        this.$store.commit('updateReady', 'contractType')
      } else {
        this.$store.commit('updateReady', 'surfaceRange')
      }
    })
  }
}
</script>
